<template>
  <div class="dashboard-tabs-offset">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "DashboardTabsOffset.vue"
};
</script>

<style lang="scss" scoped>
.dashboard-tabs-offset {
  margin-top: -15px;
}
</style>
